export default "__VITE_ASSET__DOeR2i0X__"